var _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSwarmIcon = props => {
  const _uid = React.useId().replace(/:/g, '');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: _uid + "swarm-icon_svg__a",
    cx: "70%",
    cy: "15%",
    r: "100%",
    fx: "70%",
    fy: "15%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#3b59d8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    style: {
      stopColor: "#6b6eb3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "65%",
    style: {
      stopColor: "#e89a5e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#f7c05f"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#" + _uid + "swarm-icon_svg__a)",
    d: "M20 10a10 10 0 0 1-10 10A10 10 0 0 1 0 10a10 10 0 0 1 20 0"
  }), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "52%",
    fill: "#fff",
    dominantBaseline: "middle",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 900,
    textAnchor: "middle"
  }, "S")));
};
export { SvgSwarmIcon as ReactComponent };
export default __webpack_public_path__ + "89e45e4dfe9dd148dc33993cd430d03f.svg";